const block_icons     = {
    qoute_icon: <svg
    xmlns="http://www.w3.org/2000/svg"
    width="512"
    height="512"
    enableBackground="new 0 0 512 512"
    viewBox="0 0 508.044 508.044"
  >
    <g xmlns="http://www.w3.org/2000/svg" fill="#b72121">
      <path
        d="M.108 352.536c0 66.794 54.144 120.938 120.937 120.938 66.794 0 120.938-54.144 120.938-120.938s-54.144-120.937-120.938-120.937c-13.727 0-26.867 2.393-39.168 6.61C109.093 82.118 230.814-18.543 117.979 64.303-7.138 156.17-.026 348.84.114 352.371c0 .055-.006.104-.006.165zM266.169 352.536c0 66.794 54.144 120.938 120.938 120.938s120.938-54.144 120.938-120.938S453.9 231.599 387.106 231.599c-13.728 0-26.867 2.393-39.168 6.61C375.154 82.118 496.875-18.543 384.04 64.303 258.923 156.17 266.034 348.84 266.175 352.371c0 .055-.006.104-.006.165z"
        data-original="#000000"
      ></path>
    </g>
  </svg>
}
export default block_icons;